module.exports = __webpack_public_path__ + "8f031f08cb59a4fdeb8845ff68ad14b5.png";